import { render, staticRenderFns } from "./WorkflowDesigner.vue?vue&type=template&id=2d270efd"
import script from "./WorkflowDesigner.vue?vue&type=script&lang=js"
export * from "./WorkflowDesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports